import { useEffect } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export default function AdminLayout() {
  const restore = useAuthStore((s) => s.restore);
  const initialized = useAuthStore((s) => s.initialized);
  const isAdmin = useAuthStore((s) => s.isAdmin);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (!initialized) {
      void restore();
    }
  }, [initialized, restore]);

  return (
    <div className="admin-shell">
      <aside className="admin-side">
        <div className="admin-side__logo">Gency03 관리자</div>
        <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'is-active' : '')}>
          대시보드
        </NavLink>
        <NavLink to="/admin/products" className={({ isActive }) => (isActive ? 'is-active' : '')}>
          상품 · 재고
        </NavLink>
        <NavLink to="/admin/categories" className={({ isActive }) => (isActive ? 'is-active' : '')}>
          카테고리
        </NavLink>
        <NavLink to="/admin/orders" className={({ isActive }) => (isActive ? 'is-active' : '')}>
          주문 · 배송
        </NavLink>
        {isAdmin() && (
          <NavLink to="/admin/users" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            회원 관리
          </NavLink>
        )}
        <Link to="/">← 쇼핑몰로</Link>
      </aside>

      <div className="admin-main">
        <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--gray-600)' }}>
          {user?.name} ({user?.role})
        </div>
        <Outlet />
      </div>
    </div>
  );
}
